import React from 'react';
import { Rect, Text, Image } from 'react-konva';
import {
  isMobilePhone,
} from '../../../library/calc';


export const RemotematchBox = ({
    n,
    left,
    top,
    stopStageClickPropagation,
    yCoord4Matchbox,
    width4Matchbox,
    leftStart4Boxes,
    paddingBetweenBoxes,
    matchBoxHeight,
    rm,
    // pr_id,
    // onTouchMatch,
    matchesColors,
    // cursorBecomesMove,
    // cursorBecomesPointer,
  }) => {

  rm = (typeof(rm) !== 'undefined' ? parseInt(rm, 10 ): 0 );

  left += leftStart4Boxes;
  left += width4Matchbox;
  left += paddingBetweenBoxes;
  top += yCoord4Matchbox;

  // const prId = pr_id;
  // const href = `/fwd/myheritage?profile_id=${prId}&match_type=record&src=canvas-tree&cmp=btn&trn=partner_Geni&trp=match_button_tree`;

  return <Rect
    x={left}
    y={top}
    width={width4Matchbox}
    height={matchBoxHeight}
    cursor="pointer"
    fill={( rm === 0 ? matchesColors.empty : matchesColors.record)}
    cornerRadius={0}

    // onTouchStart={()=>{
    //   stopStageClickPropagation({fromWhere:'rm - A'});
    //   if(rm > 0) onTouchMatch(href);
    // }}

    // onClick={()=> {
    //   if(isMobilePhone() ) return;
    //   stopStageClickPropagation({fromWhere:'rm - B'});
    //   if(rm > 0) window.open(href, '_blank') ;else console.log('record match - n', n)
    // }}

    // onMouseenter={()=>{
    //   if(rm > 0) cursorBecomesPointer();
    // }}
    // onMouseleave={()=>{
    //   cursorBecomesMove();
    // }}
  />;
};



export const RmLabel = ({
    rm,
    // pr_id,
    // onTouchMatch,
    // cursorBecomesMove,
    // cursorBecomesPointer,
    fillMatchBubbleContent,
    matchBubbleContent,
    left,
    top,
    nm,
    width4Matchbox,
    leftStart4Boxes,
    paddingBetweenBoxes,
    topMatchLabel,
    leftStart4MatchLabel,
    fontSizeMatchCount,
    fontFamilyMatchLabel,
    textWidth,
    n,
    // stopStageClickPropagation,
  }) => {

    rm = (typeof(rm) !== 'undefined' ? parseInt(rm, 10 ): 0 );
    left += leftStart4Boxes;
    left += width4Matchbox;
    left += paddingBetweenBoxes;
    left += leftStart4MatchLabel;
    top += topMatchLabel;

    const textIs = (rm < 100 ? rm.toString(): '99+');
    // const prId = pr_id;
    // const href = `/fwd/myheritage?profile_id=${prId}&match_type=record&src=canvas-tree&cmp=btn&trn=partner_Geni&trp=match_button_tree`;

    return <Text
      x={left}
      y={top}
      text={textIs}
      fontSize={fontSizeMatchCount}
      fontFamily={fontFamilyMatchLabel}
      fill='white'
      align='center'
      width={textWidth}

    //   onTouchStart={()=>{
    //     stopStageClickPropagation({fromWhere:'rm - C'});
    //     if(rm > 0) onTouchMatch(href);
    //   }}

    //   onClick={()=> {
    //     if(isMobilePhone() ) return;
    //     stopStageClickPropagation({fromWhere:'rm - D'});
    //     if(rm > 0) window.open(href, '_blank') ;else console.log('record match - n', n)
    //   }}

    //   onMouseenter={()=>{
    //     if(rm > 0) cursorBecomesPointer();
    //   }}

    //   onMouseleave={()=>{
    //     cursorBecomesMove();
    // }}
    />;
  };


  export const RemotematchGraph = ({
    n,
    rm,
    left,
    top,
    yCoord4Matchbox,
    width4Matchbox,
    leftStart4Boxes,
    paddingBetweenBoxes,
    matchBoxHeight,
    leftMargin,
    topStart4Graph,
    width4graph,
    height4Graph,
    cornerRadius,
    // pr_id,
    // onTouchMatch,
    // cursorBecomesMove,
    // cursorBecomesPointer,
    // stopStageClickPropagation,
  }) => {

  rm = (typeof(rm) !== 'undefined' ? parseInt(rm, 10 ): 0 );

  left += leftStart4Boxes;
  left += width4Matchbox;
  left += paddingBetweenBoxes + leftMargin;
  top += yCoord4Matchbox + topStart4Graph;

  // const prId = pr_id;
  // const href = `/fwd/myheritage?profile_id=${prId}&match_type=record&src=canvas-tree&cmp=btn&trn=partner_Geni&trp=match_button_tree`;

  return <Rect
    x={left}
    y={top}
    width={width4graph}
    height={height4Graph}
    cursor="pointer"
    fill="white"
    cornerRadius={cornerRadius}

    // onTouchStart={()=>{
    //   stopStageClickPropagation({fromWhere:'rm - E'});
    //   if(rm > 0) onTouchMatch(href);
    // }}

    // onClick={()=> {
    //   if(isMobilePhone() ) return;
    //   stopStageClickPropagation({fromWhere:'rm - F'});
    //   if(rm > 0) window.open(href, '_blank') ;else console.log('record match - n', n)
    // }}

    // onMouseenter={()=>{
    //   if(rm > 0) cursorBecomesPointer();
    // }}

    // onMouseleave={()=>{
    //   cursorBecomesMove();
    // }}
  />;
  };

  export const RemotematchGraphTip = ({
      n,
      rm,
      left,
      top,
      yCoord4Matchbox,
      width4Matchbox,
      leftStart4Boxes,
      paddingBetweenBoxes,
      matchBoxHeight,
      leftMargin,
      topStart4Graph,
      width4graph,
      height4Graph,
      cornerRadius,
      fillcolor,
      rm_vscore,
      pr_id,
      // onTouchMatch,
      // cursorBecomesMove,
      // cursorBecomesPointer,
      stopStageClickPropagation,
    }) => {

    left += leftStart4Boxes;
    left += width4Matchbox;
    left += paddingBetweenBoxes + leftMargin;
    top += yCoord4Matchbox + topStart4Graph;

    const width = ( parseInt(rm_vscore, 10) === 0 ? 0 : 2);
    // const prId = pr_id;
    // const href = `/fwd/myheritage?profile_id=${prId}&match_type=record&src=canvas-tree&cmp=btn&trn=partner_Geni&trp=match_button_tree`;

    return <Rect
      x={left}
      y={top}
      width={width}
      height={height4Graph}
      cursor="pointer"
      fill={fillcolor}
      cornerRadius={cornerRadius}

      // onTouchStart={()=>{
      //   stopStageClickPropagation({fromWhere:'rm - G'});
      //   if(rm > 0) onTouchMatch(href);
      // }}

      // onClick={()=> {
      //   if(isMobilePhone() ) return;
      //   stopStageClickPropagation({fromWhere:'rm - H'});
      //   if(rm > 0) window.open(href, '_blank') ;else console.log('record match - n', n)
      // }}

      // onMouseenter={()=>{
      //   if(rm > 0) cursorBecomesPointer();
      // }}

      // onMouseleave={()=>{
      //   cursorBecomesMove();
      // }}
    />;
  };

  export const RemotematchGraphFill = ({
      n,
      left,
      top,
      yCoord4Matchbox,
      width4Matchbox,
      leftStart4Boxes,
      paddingBetweenBoxes,
      matchBoxHeight,
      leftMargin,
      topStart4Graph,
      width4graph,
      height4Graph,
      cornerRadius,
      fillcolor,
      rm_vscore,
      defaultWidth4Graph,
      pr_id,
      // onTouchMatch,
      // cursorBecomesMove,
      // cursorBecomesPointer,
      rm,
      // stopStageClickPropagation,
    }) => {

    rm = (typeof(rm) !== 'undefined' ? parseInt(rm, 10 ): 0 );
    left += leftStart4Boxes;
    left += width4Matchbox;
    left += paddingBetweenBoxes + leftMargin + 1;
    top += yCoord4Matchbox + topStart4Graph;

    // const prId = pr_id;
    // const href = `/fwd/myheritage?profile_id=${prId}&match_type=record&src=canvas-tree&cmp=btn&trn=partner_Geni&trp=match_button_tree`;

    const width = (typeof(rm_vscore) !== 'undefined' ? defaultWidth4Graph * (rm_vscore / 100) : 'auto')

    return <Rect
      x={left}
      y={top}
      width={width}
      height={height4Graph}
      cursor="pointer"
      fill={fillcolor}

      // onTouchStart={()=>{
      //   stopStageClickPropagation({fromWhere:'rm - I'});
      //   if(rm > 0) onTouchMatch(href);
      // }}

      // onClick={()=> {
      //   if(isMobilePhone() ) return;
      //   stopStageClickPropagation({fromWhere:'rm - J'});
      //   if(rm > 0) window.open(href, '_blank') ;else console.log('record match - n', n)
      // }}

      // onMouseenter={()=>{
      //   if(rm > 0) cursorBecomesPointer();
      // }}

      // onMouseleave={()=>{
      //   cursorBecomesMove();
      // }}

    />;
  };


export class RecordMatchIcon extends React.Component {

    render() {

      let {
        left,
        top,
        leftStart4Boxes,
        width4Matchbox,
        paddingBetweenBoxes,
        leftStart4MatchLabel,
        topMatchLabel,
        iconWidth,
        leftStart4Icon,
        recordImg,
        // pr_id,
        // onTouchMatch,
        // cursorBecomesMove,
        // cursorBecomesPointer,
        // rm,
        // n,
        // stopStageClickPropagation,
      } = this.props;

      left += leftStart4Boxes;
      left += leftStart4MatchLabel + leftStart4Icon;
      left += width4Matchbox;
      left += paddingBetweenBoxes;
      top += topMatchLabel - .2;

      const dim = iconWidth;
      // const prId = pr_id;
      // const href = `/fwd/myheritage?profile_id=${prId}&match_type=record&src=canvas-tree&cmp=btn&trn=partner_Geni&trp=match_button_tree`;

      return (
          <Image
            image={recordImg}
            scaleX={.1}
            scaleY={.1}
            width={dim * 10}
            height={dim * 10}
            x={left}
            y={top}

            // onTouchStart={()=>{
            //   stopStageClickPropagation({fromWhere:'rm - K'});
            //   if(rm > 0) onTouchMatch(href);
            // }}

            // onClick={()=> {
            //   if(isMobilePhone() ) return;
            //   stopStageClickPropagation({fromWhere:'rm - L'});
            //   if(rm > 0) window.open(href, '_blank') ;else console.log('record match - n', n)
            // }}

            // onMouseenter={()=>{
            //   if(rm > 0) cursorBecomesPointer();
            // }}
            // onMouseleave={()=>{
            //   cursorBecomesMove();
            // }}
          />
      );
    }
}


export const RemotematchTransparentEventBox = ({
    n,
    left,
    top,
    stopStageClickPropagation,
    yCoord4Matchbox,
    width4Matchbox,
    leftStart4Boxes,
    paddingBetweenBoxes,
    matchBoxHeight,
    rm,
    pr_id,
    onTouchMatch,
    matchesColors,
    cursorBecomesMove,
    cursorBecomesPointer,
    fillMatchBubbleContent,
    matchBubbleContent,
  }) => {

  rm = (typeof(rm) !== 'undefined' ? parseInt(rm, 10 ): 0 );

  left += leftStart4Boxes;
  left += width4Matchbox;
  left += paddingBetweenBoxes;
  top += yCoord4Matchbox;

  const prId = pr_id;
  const href = `/fwd/myheritage?profile_id=${prId}&match_type=record&src=canvas-tree&cmp=btn&trn=partner_Geni&trp=match_button_tree`;

  return <Rect
    x={left}
    y={top}
    width={width4Matchbox}
    height={matchBoxHeight}
    cursor="pointer"
    opacity={0}
    cornerRadius={0}

    onTouchStart={()=>{
      stopStageClickPropagation({fromWhere:'rm - A'});
      if(rm > 0) onTouchMatch(href);
    }}

    onClick={()=> {
      if(isMobilePhone() ) return;
      stopStageClickPropagation({fromWhere:'rm - B'});
      if(rm > 0) window.open(href, '_blank') ;else console.log('record match - n', n)
    }}

    onMouseenter={()=>{
      if(typeof(matchBubbleContent) === 'undefined') fillMatchBubbleContent({matchBubbleContent: `{count} pending Record Matches`, matchBubbleContentVarStr: rm});
      if(rm > 0) cursorBecomesPointer();
    }}
    onMouseleave={()=>{
      cursorBecomesMove();
      if(typeof(matchBubbleContent) !== 'undefined') fillMatchBubbleContent({matchBubbleContent: undefined, matchBubbleContentVarStr: undefined});
    }}
  />;
};



